import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_24 } from '../../../../Button'
import {
  QA_NAME_OVERVIEW_APPROVAL_APPROVE,
  QA_NAME_OVERVIEW_APPROVAL_VIEW,
} from '../RentalPortalOverviewApprovalRow.constants'
import { getCanApproveOverviewApprovalRow } from '../RentalPortalOverviewApprovalRow.utils'

function OverviewApprovalActions({
  row,
  onMouseDownDecision,
  onMouseDownProfile,
  onOpenDecision,
  onOpenProfile,
}) {
  const { t } = useTranslation()

  return (
    <>
      <Button.Outlined
        height={BUTTON_HEIGHT_24}
        qaName={QA_NAME_OVERVIEW_APPROVAL_VIEW}
        text={t('RentalPortal.OverviewActionViewKey')}
        onClick={onOpenProfile}
        onMouseDown={onMouseDownProfile}
      />
      {getCanApproveOverviewApprovalRow(row) ? (
        <Button.Contained
          height={BUTTON_HEIGHT_24}
          qaName={QA_NAME_OVERVIEW_APPROVAL_APPROVE}
          text={t('RentalPortal.OverviewActionApproveKey')}
          onClick={onOpenDecision}
          onMouseDown={onMouseDownDecision}
        />
      ) : null}
    </>
  )
}

export default OverviewApprovalActions
